export const FETCH_GET_USER_DATA = 'FETCH_GET_USER_DATA'
export const FETCH_GET_USER_DATA_SUCCESS = 'FETCH_GET_USER_DATA_SUCCESS'
export const FETCH_GET_USER_LIST = 'FETCH_GET_USER_LIST'
export const FETCH_GET_USER_LIST_SUCCESS = 'FETCH_GET_USER_LIST_SUCCESS'
export const FETCH_ADD_USER = 'FETCH_ADD_USER'
export const FETCH_ADD_USER_SUCCESS = 'FETCH_ADD_USER_SUCCESS'
export const FETCH_REMOVE_USER = 'FETCH_REMOVE_USER'
export const FETCH_REMOVE_USER_SUCCESS = 'FETCH_REMOVE_USER_SUCCESS'
export const FETCH_GET_MODELS_BY_USER = 'FETCH_GET_MODELS_BY_USER'
export const FETCH_GET_MODELS_BY_USER_SUCCESS = 'FETCH_GET_MODELS_BY_USER_SUCCESS'
export const FETCH_REMOVE_USER_INITIALIZE = 'FETCH_REMOVE_USER_INITIALIZE'
export const FETCH_GET_NEW_API_TOKEN = 'FETCH_GET_NEW_API_TOKEN'
export const FETCH_GET_NEW_API_TOKEN_SUCCESS = 'FETCH_GET_NEW_API_TOKEN_SUCCESS'
export const FETCH_DELETE_API_TOKEN = 'FETCH_DELETE_API_TOKEN'
export const FETCH_DELETE_API_TOKEN_SUCCESS = 'FETCH_DELETE_API_TOKEN_SUCCESS'
export const FETCH_SET_DARKMODE = 'FETCH_SET_DARKMODE'
export const FETCH_SET_DARKMODE_SUCCESS = 'FETCH_SET_DARKMODE_SUCCESS'
export const FETCH_GET_VALIDATION_USERID = 'FETCH_GET_VALIDATION_USERID'
export const FETCH_GET_VALIDATION_USERID_SUCCESS = 'FETCH_GET_VALIDATION_USERID_SUCCESS'
export const FETCH_CHANGE_USERID = 'FETCH_CHANGE_USERID'
export const FETCH_CHANGE_USERID_SUCCESS = 'FETCH_CHANGE_USERID_SUCCESS'
export const FETCH_CHANGE_PASSWORD = 'FETCH_CHANGE_PASSWORD'
export const FETCH_CHANGE_PASSWORD_SUCCESS = 'FETCH_CHANGE_PASSWORD_SUCCESS'
export const FETCH_NEW_PASSWORD = 'FETCH_NEW_PASSWORD'
export const FETCH_NEW_PASSWORD_SUCCESS = 'FETCH_NEW_PASSWORD_SUCCESS'

export const fetchGetUserData = (payload) => {
    // console.log(payload)
    return {
        type: FETCH_GET_USER_DATA,
        payload: {
            params:{
                token: payload
            }
        }
    }
}

export const fetchGetUserList = (payload) => {
    // console.log(payload)
    return {
        type: FETCH_GET_USER_LIST,
        payload: {
            params:{
                token: payload
            }
        }
    }
}

export const fetchAddUser = (payload) => {
    // console.log(payload)
    return {
        type: FETCH_ADD_USER,
        payload: {
            params:{
                token: payload.token,
                email: payload.email,
                organization: payload.organization,
                is_admin: payload.is_admin,
                user_id: payload.user_id
            }
        }
    }
}

export const fetchRemoveUser = (payload) => {
    console.log(payload)
    return {
        type: FETCH_REMOVE_USER,
        payload: {
            params:{
                token: payload.token,
                user_id: payload.user_id
            }
        }
    }
}

export const fetchGetModelsByUserId = (payload) => {
    // console.log(payload)
    return {
        type: FETCH_GET_MODELS_BY_USER,
        payload: {
            params:{
                token: payload.token,
                query_user: payload.query_user
            }
        }
    }
}

export const fetchRemoveUserInitialize = () => {
    // console.log(payload)
    return {
        type: FETCH_REMOVE_USER_INITIALIZE,
        payload: {
        }
    }
}

export const fetchGetNewApiToken = (idToken) => {
    return {
        type: FETCH_GET_NEW_API_TOKEN,
        payload: {
            params:{
                token: idToken
            }
        }
    }
}

export const fetchDeleteApiToken = (idToken) => {
    return {
        type: FETCH_DELETE_API_TOKEN,
        payload: {
            params:{
                token: idToken
            }
        }
    }
}

export const fetchDarkMode = (payload) => {
    // console.log(payload)
    return {
        type: FETCH_SET_DARKMODE,
        payload: {
            params:{
                token: payload.idToken,
                dark_mode: payload.dark_mode
            }
        }
    }
}

export const fetchGetValidationUserId = (payload) => {
    // console.log(payload)
    return {
        type: FETCH_GET_VALIDATION_USERID,
        payload: {
            params:{
                token: payload.idToken,
                user_id: payload.user_id
            }
        }
    }
}

export const fetchChangeUserId = (payload) => {
    // console.log(payload)
    return {
        type: FETCH_CHANGE_USERID,
        payload: {
            params:{
                token: payload.idToken,
                user_id: payload.user_id
            }
        }
    }
}

export const fetchChangePassword = (payload) => {
    // console.log(payload)
    return {
        type: FETCH_CHANGE_PASSWORD,
        payload: {
            params:{
                email: payload.email
            }
        }
    }
}

export const fetchNewPassword = (payload) => {
    console.log(payload)
    return {
        type: FETCH_NEW_PASSWORD,
        payload: {
            params:{
                action_code: payload.action_code,
                new_password: payload.new_password
            }
        }
    }
}